module.exports = __webpack_public_path__ + "img/9_73.16789f25.png";